/* eslint-disable */

import request from '@/utils/request'

export function getTransactionApi(query) {
  return request({
    url: '/config-service/v1/transaction/transaction',
    method: 'get',
    params: query
  })
}

export function getSubTransactionApi(query) {
  return request({
    url: '/config-service/v1/transaction/sub-transaction/',
    method: 'get',
    params: query
  })
}

export function addTransactionApi(query) {
  return request({
    url: '/config-service/v1/transaction/transaction',
    method: 'post',
     data: query
  })
}

export function updateTransactionApi(query) {
  return request({
    url: '/config-service/v1/transaction/transaction',
    method: 'put',
     data: query
  })
}

export function deleteTransactionApi(query) {
  return request({
    url: '/config-service/v1/transaction/transaction',
    method: 'delete',
    data: query
  })
}
